import * as React from "react";
import moment from "moment";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button } from "@mui/material";
import { CurrencyFormater } from "../utilities/helperFunctions";
import { ButtonDisplayPayment } from "../../pages/PremiumPaymentsHistory";
import { createElement } from "react";

const Component = (item) => {
  return React.createElement('', '', <ButtonDisplayPayment item={item} />)
}

export default function BasicTable(props) {
  const { style,valueToCompare,ifTrueComponent,
    toFormat,type, notTrueComponent,heading, 
    searchInput, data, color,searchCondition, 
    adminType, values,actionComponent,doAction,config} = props;
  const formatDate = moment;
  let checkValue;
  let vals = []; 

  let tentativeHeading
  if(adminType === 2){
    tentativeHeading = heading.filter(i => i !== 'Actions')
  }else {
    tentativeHeading = heading
  }

  if (heading !== undefined) {
    checkValue = heading.find((key) => key.toLowerCase() === "actions");

    values.forEach((element) => {
      element.includes(" ")
        ? vals.push(element.replace(" ", "_"))
        : vals.push(element);
    });
  }

  const actionsIncluded = vals.includes('actions')
  if(actionsIncluded){vals.pop()}

  const isAction = checkValue === undefined ? false : true;


  // method to sort specific values from object in data array
  const DisplayValues = (props) => {
    const arrayObject = props.val
    let newObject = {}
    if(vals.length > 0){
    for (let v = 0; v < vals.length; v++) {
      const element = vals[v];
      var isExist = ''
      var formatValue;
      if(toFormat !== undefined){
        for (let k=0; k<toFormat.length; k++){
          let element_k = toFormat[k].split(' ')
          let f_type = type.find(x => x === element_k[1])
          if(element === element_k[0] && f_type === 'time'){
            isExist = f_type 
            formatValue = formatDate(arrayObject[element]).format("YYYY-MM-DD")
          }if(vals[v] === element_k[0] && f_type === 'currency'){
            isExist = f_type
            formatValue = CurrencyFormater(arrayObject[element]);
          }
        }
      }
      let propval = isExist === "" ? arrayObject[element] : formatValue
      if(v <= vals.length){
        newObject = {...newObject, [element]: propval}
      }
    }}

    for (const key in newObject){
      return Object.values(newObject).map((p) => (<TableCell key={key} align={props.textAlign}>{p}</TableCell>))
    }
  }

  let tentativeArray =
      searchInput !== "" && data.length > 0
        ? data.filter((i) =>
            { if(searchCondition !== undefined){
              for(const s=0; s<searchCondition.length; i++){
              let result = i[searchCondition[s]].toLowerCase().includes(searchInput.search)
              return result !== undefined ? (result) : 'do nothing'
            }}else return data
            }
          )
        : data;

  const ConditionalRender = (props) => {
    if(valueToCompare === props.condition){
      return ifTrueComponent
    }else{
      return notTrueComponent
    }
  }

  
  const RenderComponent = (props) => {
    const item = props.item;

    const mapStrings = (el) => {
      if(el.hasOwnProperty('component')){
        return createElement(el.component, {className: el.className ? el.className : null, onClick: el.onclick ? () => el.onclick(item) : null}, el.children.length>0?
        el.children.map((c) => mapStrings(c)):el.children)}
    }

    if(Object.keys(props.StringElement).includes('component')){
      return mapStrings(props.StringElement)
    }else return actionComponent
  }

  return (
    <TableContainer component={Paper}>
      <Table sx={style} aria-label="simple table">
        <TableHead style={{ display: "table-header-group", background: color }}>
          <TableRow sx={style}>
            {tentativeHeading.map((row, i) => (
              <TableCell
                key={i + 1}
                align={props.textAlign}
                style={{ color: "#ffffff", fontWeight: 500 }}
              >
                {row}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tentativeArray.map((item, i) => (
            <TableRow sx={style}>
              <DisplayValues val={item} textAlign={props.alignValues}/>
              {isAction ? (
                <TableCell align={props.textAlign} className="action" key={i}>
                  <div className="actions-container">
                    {<RenderComponent StringElement={actionComponent} item={item}/>}
                  </div>
                </TableCell>
              ) : <TableCell align={props.textAlign}><ConditionalRender condition={item[props.propertyToCheck]} /></TableCell>}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
